import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import MiniContactForm from './MiniContactForm';
import FAQ from './FAQ';

const ABOUT_FAQ = [
  {
    question: 'How long have you been in business?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque euismod, nisi eu consectetur consectetur.'
  },
  {
    question: 'What sets your company apart?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. We pride ourselves on quality and customer service.'
  },
  {
    question: 'Are you licensed and insured?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Yes, we are fully licensed and insured.'
  },
];

function About() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    'name': 'About Copper Canyon Pressure Wash',
    'description': 'Learn about Copper Canyon Pressure Wash, your trusted partner for professional pressure washing services in Phoenix, AZ.',
    'image': {
      '@type': 'ImageObject',
      'url': [
        'https://coppercanyonpressurewash.com/Copper Canyon Pressure Wash_final logo.avif',
        'https://coppercanyonpressurewash.com/Copper Canyon Pressure Wash_final logo.webp',
        'https://coppercanyonpressurewash.com/Copper Canyon Pressure Wash_final logo.png'
      ]
    },
    'address': {
      '@type': 'PostalAddress',
      'addressLocality': 'Phoenix',
      'addressRegion': 'AZ',
      'addressCountry': 'US'
    },
    'geo': {
      '@type': 'GeoCoordinates',
      'latitude': '33.4484',
      'longitude': '-112.0740'
    },
    'url': 'https://coppercanyonpressurewash.com',
    'telephone': '+16027300728',
    'email': 'coppercanyonpressurewash@gmail.com',
    'priceRange': '$$',
    'openingHoursSpecification': [
      {
        '@type': 'OpeningHoursSpecification',
        'dayOfWeek': [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday'
        ],
        'opens': '00:00',
        'closes': '23:59'
      }
    ]
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <SEO 
        title="About Copper Canyon Pressure Wash | Our Story & Team"
        description="Learn about our mission, team, and commitment to quality pressure washing in Phoenix and surrounding areas. Trusted, experienced, and local."
        schema={aboutSchema}
        keywords="Phoenix pressure washing company, local business owner, experienced cleaning team, family owned business, Arizona pressure washing experts, customer service focused, licensed and insured, eco-friendly cleaning, professional technicians, property care specialists"
      />
      
      <div className="max-w-3xl mx-auto">
        {/* Hero/Banner Image - Recommended: 1600x400px */}
        <div className="w-full h-48 sm:h-64 md:h-80 lg:h-96 mb-8 rounded-lg overflow-hidden bg-gray-200 flex items-center justify-center">
          <img 
            src="https://images.pexels.com/photos/5652626/pexels-photo-5652626.jpeg?auto=compress&cs=tinysrgb&w=600" 
            alt="Technician pressure washing a driveway with professional equipment" 
            className="w-full h-full object-cover" 
          />
        </div>
        <div className="flex flex-col md:flex-row md:items-start gap-8 mb-8">
          {/* Inline/Content Image - Recommended: 600x400px */}
          <div className="flex-shrink-0 w-full md:w-1/2 h-48 md:h-64 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center mb-4 md:mb-0">
            <img 
              src="https://images.pexels.com/photos/5248733/pexels-photo-5248733.jpeg?auto=compress&cs=tinysrgb&w=600" 
              alt="Technician power washing a patio with a high-pressure hose" 
              className="w-full h-full object-cover" 
            />
          </div>
          <div className="flex-1">
            <h1 className="text-4xl font-bold text-[#4a3f35] mb-6">About Copper Canyon Pressure Wash</h1>
            <h2 className="text-2xl font-semibold text-[#b87c4c] mb-4">Our Story</h2>
            <p className="mb-6 text-gray-700">
              At Copper Canyon Pressure Wash, we're committed to providing exceptional pressure washing services 
              throughout the Phoenix metropolitan area. With years of experience and a dedication to quality, 
              we've become the trusted choice for both residential and commercial properties.
            </p>
            <p className="mb-6 text-gray-700">
              Our team of professional technicians uses state-of-the-art equipment and eco-friendly cleaning 
              solutions to deliver outstanding results that exceed our customers' expectations.
            </p>
            <h3 className="text-xl font-semibold text-[#4a3f35] mb-2">Our Mission</h3>
            <p className="mb-6 text-gray-700">Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nulla vitae elit libero, a pharetra augue.</p>
            <h3 className="text-xl font-semibold text-[#4a3f35] mb-2">Why Choose Us?</h3>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
              <li>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</li>
              <li>Nulla vitae elit libero, a pharetra augue.</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="max-w-2xl mx-auto mt-12 mb-12">
        <MiniContactForm />
      </div>
      <div className="mt-16">
      <FAQ items={ABOUT_FAQ} />
      </div>
      <section className="text-center mt-16">
        <h2 className="text-2xl font-semibold text-[#b87c4c] mb-4">Ready to Get Started?</h2>
        <p className="text-gray-700 mb-6">
          Contact us today for a free quote and let us help you transform your property.
        </p>
        <Link 
          to="/contact" 
          className="inline-block px-8 py-3 bg-[#b87c4c] text-white font-medium rounded-lg shadow-md hover:bg-[#a06940] transition-colors duration-200"
        >
          Contact Us
        </Link>
      </section>
    </div>
  );
}

export default About; 